import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Image, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  BLOCKS_POSITIONS,
  SHOW_MOBILE_NAV_WIDTH,
} from '../../../utils/constants/enums.js';
import { useSwipeable } from 'react-swipeable';
import { Counter, Footer } from '../../basic';
import PositionBlock from './Components/PositionBlock/PositionBlock';
import OpenStreetMap from './Components/Map/OpenStreetMap';
import { useTranslation } from 'react-i18next';
import { changeMobileSwipe } from '../../../redux/slices/coreSlice';
import { useGetBlocksWithEnglishParameterQuery } from '../../../redux/services/blocks';
import { useLocation } from 'react-router-dom';

const MiddleLayout = ({ hideRightSidebar, children }) => {
  const { i18n } = useTranslation();
  //const dispatch = useDispatch();
  const isEnglish = i18n.language === 'en';
  const location = useLocation();
  /*
  //Code that was used for identifying swipe gestures and opening the right side menu upon swipe
  const handlers = useSwipeable({
    onSwiped: (eventData) => handleMobileSwipe(eventData),
  });
*/
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [location.pathname, location.search]);

  const isMobileSwipeOpened = useSelector((s) => s.core.isMobileSwipeOpened);
  const lightBoxImages = useSelector((s) => s.core.lightBoxImages);

  const { data: blocks } = useGetBlocksWithEnglishParameterQuery(isEnglish);

  const swipeClass = (isMobileSwipeOpened && 'mobile_swiped') || '';
  /*
  //Code that was used for identifying swipe gestures and opening the right side menu upon swipe
  const handleMobileSwipe = eventData => {
    const isLeftSwipe = eventData.dir === 'Left'; // from right -> left
    const isRightSwipe = eventData.dir === 'Right'; // from left to right

    if (window.screen.width <= SHOW_MOBILE_NAV_WIDTH && isLeftSwipe) {
      dispatch(changeMobileSwipe(true));
    }
    if (window.screen.width <= SHOW_MOBILE_NAV_WIDTH && isRightSwipe) {
      dispatch(changeMobileSwipe(false));
    }
  };
*/
  return (
    <div>
      {lightBoxImages && (
        // Replaced to antd... uknown usage... is it same as Slider.jsx? which one is correct
        <Image.PreviewGroup>
          {lightBoxImages.map((src, index) => (
            <Image key={index} src={src} width="100%" />
          ))}
        </Image.PreviewGroup>
      )}

      <div className={`main-layout-page-wrapper`} /*{...handlers}*/>
        <Row align="center">
          <Col
            className={`content ${swipeClass}`}
            span={22}
            sm={{ span: 22 }}
            md={{ span: hideRightSidebar ? 22 : 15 }}
            lg={{ span: hideRightSidebar ? 22 : 16 }}
            xl={{ span: hideRightSidebar ? 20 : 15 }}
            xxl={{ span: hideRightSidebar ? 16 : 12 }}
          >
            {children}
          </Col>

          {!hideRightSidebar && (
            <Col
              className={`right-sidebar-container ${swipeClass}`}
              span={22}
              sm={{ span: 22 }}
              md={{ span: 7 }}
              lg={{ span: 6 }}
              xl={{ span: 5 }}
              xxl={{ span: 4 }}
            >
              <PositionBlock
                contentWrapper="sidebar-block-content"
                blocks={blocks}
                position={BLOCKS_POSITIONS.RIGHT_SIDEBAR}
                jobOffers={[]}
              />
            </Col>
          )}
        </Row>
      </div>

      <Counter />

      <Row align="center" style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Col
          span={22}
          md={{ span: 22 }}
          lg={{ span: 22 }}
          xl={{ span: 20 }}
          xxl={{ span: 16 }}
        >
          <PositionBlock
            contentWrapper="public-position-block-layout"
            blocks={blocks}
            position={BLOCKS_POSITIONS.FOOTER}
          />
        </Col>
      </Row>

      <OpenStreetMap />
      <Footer />
    </div>
  );
};

MiddleLayout.propTypes = {
  hideRightSidebar: PropTypes.bool,
  children: PropTypes.node,
};

export default MiddleLayout;
